import React, { useState } from 'react'
import { NumberInput } from '../../../../Components/Input/NumberInput'
import { SamePriorityBehaviour } from '../../../../Api/campaigns'
import { Dropdown, Stack } from 'office-ui-fabric-react'
import { Currencies } from '../../../../Constants/Currencies'

export function SamePriorityBehaviorInput({
  fixedPrebidValue,
  fixedPrebidCurrency,
  setFixedPrebidValue,
  setFixedPrebidCurrency,
  errorMessage,
  disabled,
}: {
  fixedPrebidValue: number | null
  fixedPrebidCurrency: string | null
  setFixedPrebidValue: (value: number | null) => void
  setFixedPrebidCurrency: (currency: string | null) => void
  errorMessage: string
  disabled: boolean
}) {
  const [behavior, setBehavior] = useState<SamePriorityBehaviour>(
    SamePriorityBehaviour.DEFAULT
  )
  return (
    <>
      <Dropdown
        label="Same Priority Behaviour"
        selectedKey={behavior}
        onChange={(evt, value?) => {
          if (!value) {
            return
          }
          const newBehavior = value.key as SamePriorityBehaviour
          if (behavior === newBehavior) {
            return
          }
          setBehavior(newBehavior)
          if (newBehavior === SamePriorityBehaviour.DEFAULT) {
            setFixedPrebidValue(null)
            setFixedPrebidCurrency(null)
          } else {
            setFixedPrebidCurrency(Currencies.EUR)
          }
        }}
        required={true}
        options={[
          { key: SamePriorityBehaviour.DEFAULT, text: 'Random' },
          {
            key: SamePriorityBehaviour.FIXED_BID,
            text: 'Fixed Prebid Bid',
          },
        ]}
        disabled={disabled}
        style={{
          flexGrow: 1,
          maxWidth: 'calc(50% - 8px)',
        }}
      />
      {behavior === SamePriorityBehaviour.FIXED_BID ? (
        <Stack horizontal>
          <NumberInput
            label="Fixed Prebid Bid Value"
            errorMessage={errorMessage}
            value={fixedPrebidValue}
            style={{
              flexGrow: 1,
              maxWidth: 'calc(50% - 8px)',
            }}
            onChange={(value?: number) =>
              setFixedPrebidValue(value === undefined ? 0 : value)
            }
            disabled={disabled}
            required
            min={0}
            max={1e9}
            precision={5}
          />
          <div style={{ width: 16 }} />
          <Dropdown
            label="Currency"
            selectedKey={fixedPrebidCurrency}
            onChange={(event, value?) => {
              if (!value) {
                return
              }
              const newFixedPrebidCurrency = value.key
              if (fixedPrebidCurrency === newFixedPrebidCurrency) {
                return
              }
              setFixedPrebidCurrency(newFixedPrebidCurrency as Currencies)
            }}
            required={true}
            options={Object.keys(Currencies).map((currency) => ({
              key: currency,
              text: currency,
            }))}
            calloutProps={{ calloutMaxHeight: 300 }}
            disabled={disabled}
            styles={{
              root: {
                flexGrow: 1,
                position: 'relative',
              },
            }}
          />
        </Stack>
      ) : null}
    </>
  )
}
